'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _components = require('components');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _auth = require('redux/modules/auth');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _uploads = require('helpers/uploads');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ProjectCover.scss');

var newKey = function newKey() {
  return Date.now();
};
var coverSupportedFormats = (0, _uploads.getUploaderAcceptableFormats)('cover');

var ProjectCover = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, projectActions, { logout: _auth.logout })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ProjectCover, _Component);

  function ProjectCover() {
    var _ref;

    (0, _classCallCheck3.default)(this, ProjectCover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProjectCover.__proto__ || (0, _getPrototypeOf2.default)(ProjectCover)).call.apply(_ref, [this].concat(args)));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(ProjectCover, [{
    key: 'onImageSelected',
    value: function onImageSelected(e) {
      this.coverCropper.onImageSelected(e);
      this.setState({ coverButtonKey: newKey() });
    }
  }, {
    key: 'onCoverUpload',
    value: function onCoverUpload(id, name, resp) {
      var code = resp.code,
          msg = resp.msg;
      var _props = this.props,
          setCover = _props.setCover,
          project = _props.project;

      if (code === 1) {
        return this.props.logout();
      }

      if (code && msg) {
        _toastr2.default.error(msg);
      }

      var cover = (0, _get4.default)(resp, 'data.imageThumb');
      if (cover) {
        setCover(project.id, cover);
      }
    }
  }, {
    key: 'deleteCover',
    value: function deleteCover() {
      var project = this.props.project;

      this.props.deleteCover(project.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          t = _props2.t,
          project = _props2.project,
          disabled = _props2.disabled;
      var coverButtonKey = this.state.coverButtonKey;

      var coverUploaderParams = { queryParams: { projectId: project.id }, endpoint: '/api/FileUpload_wa/uploadCover' };
      var isLocked = disabled;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(_components.Thumb, { className: styles.cover, fileName: project.imageThumb }),
          _react2.default.createElement(
            'div',
            { className: styles.coverActions },
            _react2.default.createElement(
              'div',
              { className: 'hint small' },
              _react2.default.createElement(
                'span',
                null,
                t('Optional - Cover picture will be displayed on the email sent to the recipients and on the player.')
              ),
              isLocked && _react2.default.createElement(
                'span',
                null,
                ' ',
                t('Upload file here.')
              )
            )
          ),
          !isLocked && _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('clearfix', styles.coverButtons) },
            _react2.default.createElement(
              'div',
              { className: 'hint small' },
              t('Images (jpg, png, bmp) accepted.')
            ),
            _react2.default.createElement(
              'label',
              { className: 'fileInputContainer margin-right-10', key: coverButtonKey },
              _react2.default.createElement(
                'span',
                { className: 'btn btn-primary margin-vert-5' },
                t('Upload new')
              ),
              _react2.default.createElement('input', { type: 'file', className: 'fileInput', accept: coverSupportedFormats, onChange: this.onImageSelected })
            ),
            _react2.default.createElement(
              'button',
              { type: 'button', className: 'btn btn-accent margin-vert-5', onClick: this.deleteCover },
              t('Delete')
            )
          )
        ),
        _react2.default.createElement(_components.CropUploader, {
          ref: function ref(el) {
            return _this2.coverCropper = el;
          },
          onUpload: this.onCoverUpload,
          className: 'margin-top-10',
          cropperClassName: styles.coverCropper,
          uploaderParams: coverUploaderParams
        })
      );
    }
  }]);
  return ProjectCover;
}(_react.Component), _class3.propTypes = {
  deleteCover: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  logout: _propTypes2.default.func,
  project: _propTypes2.default.object.isRequired,
  setCover: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onImageSelected', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onImageSelected'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onCoverUpload', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onCoverUpload'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteCover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteCover'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = ProjectCover;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Project/Cover/ProjectCover.js
// module id = 2047
// module chunks = 1